import pkg from '../../../package.json' with { type: 'json' };
import axios from 'axios';

//
// global constants
//

export type BuildInfoType = {
    date: string | undefined,
    commit: string | undefined,
    isDaily: boolean | undefined,
    isDemo: boolean | undefined,
}

let buildInfo: BuildInfoType = {
    date: undefined,
    commit: undefined,
    isDaily: undefined,
    isDemo: undefined,
}
export const getBuildInfo = async (): Promise<BuildInfoType> => {
    try {
        if (buildInfo.date === undefined && buildInfo.commit === undefined) {
            const res = await axios.get('/ping');
            const info = res.headers['x-build-info'] || null;
            if (info) buildInfo = JSON.parse(info)
            if (!buildInfo.date?.startsWith('2')) buildInfo.date = '2026-01-01T00:00:00Z'
            //buildInfo.isDemo = true
            //buildInfo.isDaily = true
        }
    } catch (e) {
        console.warn('Build info not available', e);
    }
    return { ...buildInfo }
}


// the app version
export const appVersion = pkg.version

// top header
export const headerHeight = 56

// flexlayout in percent %
export const defaultSidebarWidth = 15

// slpitter

export const minSidebarWidth = 56
export const maxSidebarWidth = 260

export const minSplitterWidth = 200

// pagination
export const defaultRowsPerPage = 20

// how long a server message stays on screen, in ms — a sentence needs
// longer to read than "Successfully saved"
export const errorNoticeDuration = 8000
